import { Spinner } from "@chakra-ui/react";

export const Loader = () => <Spinner />;
